import { FETCH_CONFIGURATION } from './types';
import {
  getStripeCustomApiKey,
  initializeBackend,
  initializeFacebook,
  initializeGoogle,
  initializeLocalize,
} from '../../api';
import {
  ORDER_TYPE_CLICK_AND_COLLECT,
  ORDER_TYPE_CLICK_AND_SEAT,
  ORDER_TYPE_DELIVERY,
} from '../../constants';
import store from '../store';
import { getCompanyWebAppConfiguration } from '../../api/company';

export const fetchConfiguration = async (companyId) => {
  const configVal = await getCompanyWebAppConfiguration(companyId);
  const { domain, google, localize, facebook } = configVal;
  initializeFacebook(facebook || {});
  initializeGoogle(google || {});
  initializeBackend(domain);
  initializeLocalize(localize || {});
  const orderTypesPriority = [
    ORDER_TYPE_DELIVERY,
    ORDER_TYPE_CLICK_AND_COLLECT,
    ORDER_TYPE_CLICK_AND_SEAT,
  ];
  configVal.orderTypes = orderTypesPriority.filter((type) =>
    configVal?.orderTypes?.includes(type)
  );
  configVal.stripeApiKey = await getStripeCustomApiKey(configVal.id);
  store.dispatch({ type: FETCH_CONFIGURATION, payload: configVal });
};
